import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} cannot be earlier than Effective Date.`
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var effDate = args[0]
    if (effDate) {
      // if (isAfter(removeTime(effDate), removeTime(value))) {
      //   return false
      // } else {
      //   return true
      // }
      return !(isAfter(removeTime(effDate), removeTime(value)))
    } else {
      return true
    }
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
